module.exports = __webpack_public_path__ + "img/img49.f5dd9ad5.png";